import { useQuery } from '@tanstack/react-query';
import { useConfigContext } from '../context';
import { getBranding } from '../api/queries/branding';
import { StrictBrandingSchema, TBranding } from '../api';
import * as v from 'valibot';

type WindowWithBranding = Window & {
  branding?: TBranding;
};

const readGlobalBranding = () => {
  const branding = (window as WindowWithBranding)?.branding;

  if (branding) {
    const validatedResponse = v.safeParse(StrictBrandingSchema, branding);

    if (validatedResponse.success) {
      return validatedResponse.output;
    }
  }

  return null;
};

export const useBranding = ({
  brandingId,
  bypassGlobalBranding,
  enabled = true,
}: {
  brandingId: number;
  bypassGlobalBranding?: boolean;
  enabled?: boolean;
}) => {
  const { config } = useConfigContext();

  return useQuery({
    queryKey: ['branding', brandingId],
    queryFn: () => {
      if (!bypassGlobalBranding) {
        const globalBranding = readGlobalBranding();
        if (globalBranding) {
          return globalBranding;
        }
      }

      return getBranding(config.apiUrls.aleweb, brandingId);
    },
    staleTime: Infinity,
    enabled: enabled && !!brandingId,
  });
};
